import { LOGOUT } from "../actions/auth";

import { form as senfol } from "@form-data/forms-templates/laptop_senfol";
import { form as ssapr23 } from "@form-data/forms-templates/scholarship_apr23";
import { form as ssapr24 } from "@form-data/forms-templates/scholarship_apr24";
import { form as ssapr25 } from "@form-data/forms-templates/scholarship_apr25";
import { form as ssapr26 } from "@form-data/forms-templates/scholarship_apr26";
import { form as jsjun23 } from "@form-data/forms-templates/jsjun23";
import { form as recruiterjun23 } from "@form-data/forms-templates/recruiterjun23";
import { form as laju23 } from "@form-data/forms-templates/laptop_laju23";
import { form as laptop23s7p2 } from "@form-data/forms-templates/laptop23_s7p2";
import { form as laptop24s8p1 } from "@form-data/forms-templates/laptop24_s8p1";
import { form as laptop25s9p1 } from "@form-data/forms-templates/laptop25_s9p1";
import { form as laptop25s9p2 } from "@form-data/forms-templates/laptop25_s9p2";
import { form as laptop25s9p34 } from "@form-data/forms-templates/laptop25_s9p3_4";
import { form as laptop26s10p11 } from "@form-data/forms-templates/laptop26_s10p1_1";
import { form as donation2024 } from "@form-data/forms-templates/donation_2024";
import { form as membershipregistration } from "@form-data/forms-templates/membershipregistration";
import { form as ofgjL } from "@form-data/forms-templates/laptop_ofgjL";

export const SET_FORMS = "SET_FORMS";
// import { form as testform } from "@form-data/forms-templates/scholarship_d56f4g";

// Two copies of the same are mentioned for resolving the logout issue for 2nd user.
// IMP : should always create a new object and never refer already generated value. Could be a nightmare.
// const initialState = {
// 	applications: {
// 		// dkfjg: dkfjg,
// 		// d56f4g: d56f4g,
// 		// lfkgk: lfkgk,
// 		// ofgjL: ofgjL, // has approval config.
// 		// senfol: senfol,
// 		// ssapr23: ssapr23(),
// 		// ssapr24: ssapr24(),
// 		laptop24s8p1: laptop24s8p1(),
// 		// jsjun23: jsjun23(),
// 		// recruiterjun23: recruiterjun23(),
// 		// laju23: laju23,
// 		// laptop23s7p2: laptop23s7p2,
// 		// testform: testform,
// 	},
// };

const initialState = {
	applications: {},
};

/*
`_` is not allowed in formId or aadhar(applicantId)
this causes issue during sending email.
*/

const states = (state = { ...initialState }, action) => {
	switch (action.type) {
		case SET_FORMS:
			return {
				...state,
				applications: action.forms,
			};
		case LOGOUT:
			console.log("LOGOUT in forms");
			return initialState;
		default:
			return state;
	}
};

export default states;
